module.exports = "https://s81616.cdn.ngenix.net/microcredits-frontend/_next/static/images/thirdStep-677da298f0dd5418e619b204045c07f9.png";